import { Suspense } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { SnackbarProvider } from "notistack";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { createAppRoutes } from "./AppRoutes";

import ErrorBoundary from "./contexts/ErrorBoundary";
import AppGlobalStyles from "./components/AppGlobalStyles";
import AttributionCapture from "./components/AttributionCapture";
import { appTheme } from "./ui/theme";
import { LogProvider } from "./contexts/log.provider";
import { initLogging } from "./services/logging";
import LoadingScreen from "./components/LoadingScreen";
import { ImportPoller } from "./features/import/ImportPoller";

import "./ui/css/general.scss";
import { LicenseInfo } from "@mui/x-license";

initLogging();
LicenseInfo.setLicenseKey(
  "927cfe196b9249a936273653e0a74d3aTz0xMzM1NzAsRT0xODIzODE3NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=",
);

// Root route shell. SnackbarProvider lives INSIDE the router tree so that
// snackbar action components (e.g. SnackbarUpgradeAction) can use <Link>,
// useNavigate, and other react-router APIs. Without this wrapping, notistack
// portals render outside Router context and <Link> throws
// "Cannot destructure property 'basename' of useContext() as null".
const RouterShell = () => (
  <SnackbarProvider dense maxSnack={3}>
    <ImportPoller />
    <Outlet />
  </SnackbarProvider>
);

const router = createBrowserRouter([
  {
    element: <RouterShell />,
    children: createAppRoutes(),
  },
]);

const App = () => {
  return (
    <ThemeProvider theme={appTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ErrorBoundary>
          <LogProvider>
            <AttributionCapture />
            <Suspense fallback={<LoadingScreen title="loading app" />}>
              <CssBaseline />
              <AppGlobalStyles />
              <RouterProvider router={router} />
            </Suspense>
          </LogProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
